import Page from 'components/pages/stylist-id'
import initRequest from 'request/stylist-id/init'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  const [id] = params.params

  try {
    const stylistUserId = parseInt(id)
    if (!stylistUserId) throw Error('no id')
    if (stylistUserId < 0) throw Error('no id')
    const initData = await initRequest(stylistUserId)
    const { stylist } = initData.user
    if (!stylist?.show || !stylist?.showCalendar || !stylist?.studio) throw Error('not show')

    initData.applyForms.forEach(applyForm => {
      applyForm.coverUrls = applyForm.coverImages?.slice(-3).map(image => image.photo)
    })

    const city = await store.findCity(stylist.studio.city)
    const breadcrumbResolver = () => {
      const breadcrumb = [
        {
          name: i18n.t('common:breadcrumb.stylist'),
          href: h.path.stylists()
        },
        {
          name: city.name,
          href: h.path.stylists({ city: city.key })
        },
        { name: initData.user.name }
      ]

      return breadcrumb
    }
    const breadcrumbs = breadcrumbResolver()

    return { props: { ...initData, breadcrumbs }, revalidate: 60 * 30 }
  } catch (error) {
    return {
      redirect: {
        destination: `${ h.path.stylistEvents() }?talkto=${ id }`,
        permanent: false
      }
    }
  }
}

export default function StylistId(initData) {
  const t = useI18n()
  const { user, posts, reviews } = initData
  const { stylist } = user
  const { studio } = stylist
  const url = h.path.full.stylist({ id: user.id })
  const title = t.seo.title('custom', { value: `${user.name} - ${studio.name}`, interpolation: { escapeValue: false } })
  const description = user.aboutMe.noNewLine()
  const year = dayjs().year()
  const region = ''
  reviews.forEach(review => {
    review.$largePhotos = review.photos.map(photo => photo.url.large)
  })
  posts.map(post => {
    post.alt = post.tags?.slice(0, 3).map(tag => tag.name).join('、') || ''
  })

  const rating = {}
  if (stylist.totalRatingCount) {
    const reviewTarget = stylist.isStudioAccount ? studio : stylist
    rating.aggregateRating = {
      '@type': 'AggregateRating',
      'ratingValue': reviewTarget.rating,
      'reviewCount': reviewTarget.totalRatingCount
    }
  }
  return (
    <>
      <C.Head>
        { h.seo({ title, description })}
        { h.og({ image: user.largeAvatar }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'ProfessionalService',
          'name': user.name,
          'url': url,
          'image': user.largeAvatar,
          'address': studio.address,
          'memberOf': {
            '@type': 'Organization',
            'name': studio.name,
            'url': h.path.full.studio({ id: studio.id })
          },
          'geo': {
            '@type': 'GeoCoordinates',
            'latitude': studio.lat,
            'longitude': studio.lng
          },
          'telephone': studio.phone,
          'address': studio.address,
          'priceRange': '$',
          'openingHours': studio.openTime,
          'description': description,
          ...rating
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            'position': 1,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.root(),
              'name': 'StyleMap'
            }
          }, {
            'position': 2,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.stylists(),
              'name': t('seo:stylists.title', { year, region })
            }
          }, {
            'position': 3,
            '@type': 'ListItem',
            'item': {
              '@id': url,
              'name': `${user.name} - ${studio.name}`
            }
          }]
        }) }
      </C.Head>
      <Page initData={ initData } />
    </>
  )
}
